/**
 * @generated SignedSource<<71ba2b1c42da815ec5082462c85fdc77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkedContentInput_files$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"LinkedContent_files">;
  readonly " $fragmentType": "LinkedContentInput_files";
}>;
export type LinkedContentInput_files$key = ReadonlyArray<{
  readonly " $data"?: LinkedContentInput_files$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedContentInput_files">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "LinkedContentInput_files",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkedContent_files"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "ec4155e346b2c0530c24dc620b4a61fa";

export default node;
